import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mic } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";

export default function VoiceMessagePromo() {
  const { t } = useI18n();
  return (
    <section className="px-4 py-8 sm:px-6 lg:px-8" data-testid="landing-voice-message-promo">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/15 via-card to-card p-8 sm:p-10"
        >
          <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 flex-none items-center justify-center rounded-2xl bg-primary/20 text-primary">
                <Mic className="h-6 w-6" strokeWidth={1.5} />
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-primary px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-primary-foreground" data-testid="voice-message-new-badge">
                    {t("landing.newBadge")}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-xl font-medium tracking-tight sm:text-2xl">
                  {t("landing.voiceMessagePromoTitle")}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">
                  {t("landing.voiceMessagePromoDesc")}
                </p>
              </div>
            </div>
            <div className="flex flex-none flex-wrap gap-3">
              <Link to="/message-vocal-personnalise">
                <Button variant="outline" className="rounded-full" data-testid="voice-message-promo-discover-btn">
                  {t("landing.voiceMessagePromoDiscover")}
                </Button>
              </Link>
              <Link to="/create">
                <Button className="rounded-full" data-testid="voice-message-promo-create-btn">
                  {t("landing.heroCta")}
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
